(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sc-article-share"] && !Shopify.designMode) return;
  try {
    function initArticleSharing() {
 document.querySelectorAll('.sc-share').forEach(panel => {
  if(panel.dataset.ready) return;
  panel.dataset.ready='true';
  const copy=panel.querySelector('[data-sc-copy]');
  const native=panel.querySelector('[data-sc-native]');
  const status=panel.querySelector('.sc-share__status');
  copy.hidden=false;
  copy.addEventListener('click',async () => {
   try {
    if(navigator.clipboard && window.isSecureContext) await navigator.clipboard.writeText(panel.dataset.url);
    else {
     const field=document.createElement('textarea');
     field.value=panel.dataset.url;field.style.position='fixed';field.style.opacity='0';panel.append(field);field.select();
     let ok=false;
     try {ok=document.execCommand('copy')} finally {field.remove();copy.focus()}
     if(!ok) throw new Error('Copy failed');
    }
    status.textContent=status.dataset.copied;
   } catch {status.textContent=status.dataset.failed+' '+panel.dataset.url}
  });
  if(typeof navigator.share==='function') {
   native.hidden=false;
   native.addEventListener('click',async () => {
    try {await navigator.share({title:panel.dataset.title,url:panel.dataset.url})}
    catch(error) {if(error.name!=='AbortError') status.textContent=status.dataset.failed+' '+panel.dataset.url}
   });
  }
 });
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initArticleSharing);
else initArticleSharing();
document.addEventListener('shopify:section:load',initArticleSharing);
  } catch(e) { console.error(e); }
})();

})();
